import React from "react";

function CpmpanyInformation(){
    return(
        <div className="form-content">
            <ul>
                <li>
                    <label>First & Last Name <span>*</span></label>
                    <input type="text" placeholder="first & last name of the authorized Person" />
                </li>
                <li>
                    <label>Authorized Email ID <span>*</span></label>
                    <input type="text" placeholder="please enter email id" />
                </li>                
                <li>
                    <label>Alternate Email id <span>*</span></label>
                    <input type="text" placeholder="Alternate Mail id" />
                </li>
                <li>
                    <label>Authorized Contact Number <span>*</span></label>
                    <input type="text" placeholder="authorized official contact number" />
                </li>
                <li>
                    <label>Alternate Contact Number <span>*</span></label>
                    <input type="text" placeholder="contact number" />
                </li>
                <li>
                    <label>Legal Name <span>*</span></label>
                    <input type="text" placeholder="please enter legal name" />
                </li>
                <li>
                    <label>Tax ID (PAN NO.) <span>*</span></label>
                    <input type="text" placeholder="pan number" />
                </li>
            </ul>
            <h3 className="heading3"><span>Legal/Registered</span></h3>
            <ul>
                <li>
                    <label>Legal/Registered Entity Address</label>
                    <textarea placeholder="address"></textarea>
                </li>
                <li>
                    <label>Country <span>*</span></label>
                    <select>
                        <option>Please Select</option>
                        <option>Please Select</option>
                    </select>
                </li>
                <li>
                    <label>City</label>
                    <select>
                        <option>Please Select</option>
                        <option>Please Select</option>
                    </select>
                </li>
                <li>
                    <label>Region</label>
                    <input type="text" placeholder="Region" />
                </li>
                
                <li>
                    <label>Postal Zip Code</label>
                    <input type="text" placeholder="Postal Zip Code" />
                </li>
            </ul>
            <h3 className="heading3"><span>Headquarters Entity Address</span></h3>
            <ul>
                <li>
                    <label>Headquarters Entity Address</label>
                    <textarea placeholder="address"></textarea>
                </li>
                <li>
                    <label>Country <span>*</span></label>
                    <select>
                        <option>Please Select</option>
                        <option>Please Select</option>
                    </select>
                </li>
                <li>
                    <label>City</label>
                    <select>
                        <option>Please Select</option>
                        <option>Please Select</option>
                    </select>
                </li>
                <li>
                    <label>Region <span>*</span></label>
                    <input type="text" placeholder="Region" />
                </li>
                
                <li>
                    <label>Postal Zip Code</label>
                    <input type="text" placeholder="Postal Zip Code" />
                </li>
                <li>
                    <label>Incorporation Date</label>
                    <input type="date" />
                </li>
            </ul>
            
            {/* <h3 className="heading3"><span>DIRECTPARENT</span></h3>
            <ul>
                <li>
                    <label>Direct Present (If Reason is No) <span>*</span></label>
                    <input type="text" placeholder="Direct Present (If Reason is No)" />
                </li>
                <li>
                    <label>Direct Parent Present (If Yes) <span>*</span></label>
                    <input type="text" placeholder="Direct Parent Present (If Yes)" />
                </li>
                <li>
                    <label>Start date of relationship <span>*</span></label>
                    <input type="text" placeholder="Start date of relationship" />
                </li>            
            </ul> 
            <h3 className="heading3"><span>ULTIMATEPARENT</span></h3>
            <ul>
                <li>
                    <label>Ultimate Present (If Reason is No) <span>*</span></label>
                    <input type="text" placeholder="Ultimate Present (If Reason is No)" />
                </li>
                <li>
                    <label>Ultimate Parent has LEI ?  ( If Yes& also same as DP) <span>*</span></label>
                    <input type="text" placeholder="Ultimate Parent has LEI ?  ( If Yes& also same as DP)" />
                </li>
                <li>
                    <label>Ultimate Parent Name <span>*</span></label>
                    <input type="text" placeholder="Ultimate Parent Name" />
                </li>
                <li>
                    <label>Start date of relationship <span>*</span></label>
                    <input type="text" placeholder="Start date of relationship" />
                </li>            
            </ul> 
            <h3 className="heading3"><span>LEGAL FORM - BRANCH/FUND RELATIONS</span></h3>
            <ul>
                <li>
                    <label>Registration Tab (Project Office)</label>
                    <input type="text" placeholder="Registration Tab (Project Office)" />
                </li>
                <li>
                    <label>LEI Number (If Yes/No) <span>*</span></label>
                    <input type="text" placeholder="LEI Number (If Yes/No)" />
                </li>
            </ul>  */}
            {/* <h3 className="heading3"><span>PAYMENT</span></h3>
            <ul>
                <li>
                    <label>Mode Of Payment  (Payment gateway) <span>*</span></label>
                    <input type="text" placeholder="Mode Of Payment  (Payment gateway)" />
                </li>
                <li>
                    <label>GST Number <span>*</span></label>
                    <input type="text" placeholder="GST Number" />
                </li>
                <li>
                    <label>No of Years <span>*</span></label>
                    <input type="text" placeholder="No of Years" />
                </li>
            
            </ul>     */}
        </div>
    );
}export default CpmpanyInformation